import { createClient } from 'contentful'

let contentfulClient = createClient({
    space: '8l79e8foftaj',
    accessToken: 'GWVr0A3Wk-Mo3rYDtejKSfGrJXoJDimmVPhY92sYJFY'
})

export default contentfulClient;